import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'
import { WarningAmber } from '@mui/icons-material'

export function M_MessageBoard({ title, open, onClose,
    body, footer, minWidth, warning, maxWidth, left,
    right, top, bottom, height }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: minWidth,
                    maxWidth: maxWidth,
                    position: 'absolute',
                    height: height,
                    top: top,
                    bottom: bottom,
                    left: left,
                    right: right
                }
            }}
        >
            <DialogTitle className='textInherit' style={{ display: 'flex', alignItems: 'center' }}>
                {warning && <WarningAmber style={{ color: 'var(--color-red)', marginRight: '10px' }} />}
                <b>{title}</b>
            </DialogTitle>
            <DialogContent >
                {body}
            </DialogContent>
            <DialogActions >
                {footer}
            </DialogActions>
        </Dialog>
    )
}